import { BaseProtoUuidDto } from './base-proto-uuid.dto';

/**
 * Base search DTO
 */
export abstract class BaseProtoSearchDto extends BaseProtoUuidDto {}
